import { z } from 'zod'

export const imageSchema = z.object({
  _id: z.string().nullish(),
  id: z.string().nullish(),
  deleted: z.boolean().nullish(),
  primary: z.boolean().nullish(),
  small: z.string().nullish(),
  medium: z.string().nullish(),
  large: z.string().nullish(),
  xlarge: z.string().nullish(),
  original: z.string().nullish(),
  filename: z.string().nullish(),
})
